import React from 'react';
import { path } from 'ramda';
import Translate from 'react-translate-component';

import { DefinitionHeader } from 'components/common/fields/DefinitionHeader';
import { DefinitionField } from 'components/common/fields/DefinitionField';
import { DateTimeField } from 'components/common/fields/DateTimeFields';

export const ApplicationCard = ({ item }) => {
    const vacancy = path(['vacancy', 'name'], item);
    const sender = path(['people', 'name'], item);
    const date = item.date || path(['send', 'date'], item);
    const time = item.time || path(['send', 'time'], item);

    return (
        <div>
            <DefinitionHeader translate="common.general" iconType='info-outline' />
            <div className="panel-view">
                <DefinitionField
                    translate="education.application.headers.vacancy"
                    text={vacancy}
                />
                <DefinitionField
                    translate="education.application.headers.sender"
                    text={sender}
                />
                <DefinitionField translate="education.application.headers.datetime">
                    <DateTimeField date={date} time={time} />
                </DefinitionField>
                <DefinitionField translate="education.common.substate" show={!!item.approveState}>
                    <Translate content={`education.common.approveState.${item.approveState}`} />
                </DefinitionField>
            </div>
            <DefinitionHeader translate="education.application.title" iconType='comment' />
            <div className="panel-view text-pre-space">
                {item.comment}
            </div>
        </div>
    );
}
